<template>
  <div class="about-page">
    <nav-header></nav-header>

    <div class="page-container">
      <!-- 页面标题区域 -->
      <div class="page-header">
        <div class="header-content">
          <h1 class="page-title">关于我们</h1>
          <div class="title-decoration">
            <div class="decoration-line"></div>
            <div class="decoration-dot"></div>
            <div class="decoration-line"></div>
          </div>
          <p class="page-subtitle">ABOUT US</p>
        </div>
      </div>

      <!-- 主要内容区域 -->
      <div class="main-content">
        <div class="content-card">
          <!-- 公司基本信息 -->
          <div class="company-intro">
            <div class="company-header">
              <div class="company-logo-section">
                <div class="company-logo">
                  <i class="logo-icon"></i>
                </div>
                <div class="company-info">
                  <h2 class="company-name">
                    北京质子游戏科技有限公司
                  </h2>
                  <div class="company-tags">
                    <span class="company-tag">游戏科技</span>
                    <span class="company-tag">文化创意</span>
                    <span class="company-tag">技术服务</span>
                  </div>
                </div>
              </div>
              <div class="company-badge">
                <span class="badge-item">
                  <i class="badge-icon icon-calendar"></i>
                  成立于2023年
                </span>
                <span class="badge-item">
                  <i class="badge-icon icon-location"></i>
                  北京朝阳区
                </span>
                <span class="badge-item">
                  <i class="badge-icon icon-certificate"></i>
                  网络文化经营许可证
                </span>
              </div>
            </div>

            <!-- 公司核心业务 -->
            <div class="business-overview">
              <div class="business-section">
                <div class="section-header">
                  <div class="section-icon">
                    <i class="icon-rocket"></i>
                  </div>
                  <h3>公司概况</h3>
                </div>
                <div class="section-content">
                  <p>
                    北京质子游戏科技有限公司成立于2023年06月13日，注册地位于北京市朝阳区管庄双桥路8号咸宁产业园D区一层1091。
                  </p>
                </div>
              </div>

              <div class="business-section">
                <div class="section-header">
                  <div class="section-icon">
                    <i class="icon-business"></i>
                  </div>
                  <h3>经营范围</h3>
                </div>
                <div class="section-content">
                  <div class="business-categories">
                    <div class="category-item">
                      <h4>一般项目</h4>
                      <ul class="business-list">
                        <li>技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广</li>
                        <li>广告制作、广告发布、广告设计、代理</li>
                        <li>组织文化艺术交流活动</li>
                        <li>会议及展览服务</li>
                        <li>企业形象策划</li>
                      </ul>
                    </div>
                    <div class="category-item">
                      <h4>许可项目</h4>
                      <ul class="business-list">
                        <li>网络文化经营</li>
                      </ul>
                      <p class="note-text">
                        （依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 核心优势 -->
            <div class="core-advantages">
              <h3 class="advantages-title">核心优势</h3>
              <div class="advantages-grid">
                <div class="advantage-item">
                  <div class="advantage-icon">
                    <i class="icon-tech"></i>
                  </div>
                  <h4>技术实力</h4>
                  <p>拥有专业的技术团队，提供全方位的技术服务和解决方案</p>
                </div>
                <div class="advantage-item">
                  <div class="advantage-icon">
                    <i class="icon-creative"></i>
                  </div>
                  <h4>创意设计</h4>
                  <p>专业的广告设计和企业形象策划，助力品牌建设</p>
                </div>
                <div class="advantage-item">
                  <div class="advantage-icon">
                    <i class="icon-culture"></i>
                  </div>
                  <h4>文化传播</h4>
                  <p>丰富的文化艺术交流活动组织经验，推动文化产业发展</p>
                </div>
                <div class="advantage-item">
                  <div class="advantage-icon">
                    <i class="icon-license"></i>
                  </div>
                  <h4>合规经营</h4>
                  <p>持有网络文化经营许可证，确保业务合规开展</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <nav-footer></nav-footer>
  </div>
</template>

<script>
import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";
export default {
  name: "info",
  components: {
    NavFooter,
    NavHeader,
  },
  data() {
    return {
      href: "index.html",
    };
  },
  mounted() {
    document.title = "北京质子游戏科技有限公司";
  },
  methods: {
    goInfo() {
      this.$router.push("/info");
    },
    goXy() {
      this.$router.push("/xy");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.about-page {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf6 100%);
  box-sizing: border-box;

  .page-container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 40px 20px 60px;
  }

  .page-header {
    text-align: center;
    margin-bottom: 60px;
    padding: 60px 0 40px;

    .header-content {
      .page-title {
        font-size: 48px;
        font-weight: bold;
        color: #1e3c72;
        margin-bottom: 20px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      .title-decoration {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;

        .decoration-line {
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, transparent, #ff6b35, transparent);
        }

        .decoration-dot {
          width: 12px;
          height: 12px;
          background: #ff6b35;
          border-radius: 50%;
          margin: 0 20px;
        }
      }

      .page-subtitle {
        font-size: 18px;
        color: #666;
        letter-spacing: 8px;
        text-transform: uppercase;
      }
    }
  }

  .main-content {
    .content-card {
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-radius: 20px;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.8);
      overflow: hidden;
      margin-bottom: 40px;
    }

    .company-intro {
      padding: 50px;

      .company-header {
        margin-bottom: 50px;
        padding-bottom: 30px;
        border-bottom: 1px solid rgba(30, 60, 114, 0.1);

        .company-logo-section {
          display: flex;
          align-items: center;
          margin-bottom: 30px;

          .company-logo {
            width: 80px;
            height: 80px;
            background: linear-gradient(135deg, #1e3c72, #2a5298);
            border-radius: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 25px;
            box-shadow: 0 10px 20px rgba(30, 60, 114, 0.2);

            .logo-icon {
              width: 40px;
              height: 40px;
              background: linear-gradient(135deg, #ff6b35, #ff8e35);
              border-radius: 10px;
              position: relative;

              &::before {
                content: "质";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: white;
                font-size: 20px;
                font-weight: bold;
              }
            }
          }

          .company-info {
            .company-name {
              font-size: 36px;
              font-weight: bold;
              color: #1e3c72;
              margin-bottom: 15px;
            }

            .company-tags {
              display: flex;
              gap: 15px;

              .company-tag {
                padding: 6px 16px;
                background: linear-gradient(135deg, rgba(30, 60, 114, 0.1), rgba(255, 107, 53, 0.1));
                color: #1e3c72;
                border-radius: 15px;
                font-size: 14px;
                font-weight: 500;
                border: 1px solid rgba(30, 60, 114, 0.2);
              }
            }
          }
        }

        .company-badge {
          display: flex;
          justify-content: center;
          gap: 25px;

          .badge-item {
            display: flex;
            align-items: center;
            padding: 12px 24px;
            background: linear-gradient(135deg, #1e3c72, #2a5298);
            color: white;
            border-radius: 25px;
            font-size: 14px;
            font-weight: 500;
            box-shadow: 0 4px 12px rgba(30, 60, 114, 0.3);
            transition: all 0.3s ease;

            &:hover {
              transform: translateY(-3px);
              box-shadow: 0 6px 20px rgba(30, 60, 114, 0.4);
            }

            .badge-icon {
              width: 18px;
              height: 18px;
              margin-right: 8px;
              position: relative;

              &::before {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                color: white;
                font-size: 14px;
              }
            }

            .icon-calendar::before { content: "📅"; }
            .icon-location::before { content: "📍"; }
            .icon-certificate::before { content: "📜"; }
          }
        }
      }

      .business-overview {
        .business-section {
          margin-bottom: 40px;
          padding: 30px;
          background: rgba(255, 255, 255, 0.7);
          border-radius: 15px;
          border-left: 4px solid #ff6b35;
          transition: all 0.3s ease;

          &:hover {
            transform: translateX(10px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
          }

          .section-header {
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            .section-icon {
              width: 50px;
              height: 50px;
              background: linear-gradient(135deg, #1e3c72, #2a5298);
              border-radius: 12px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 20px;

              i {
                color: white;
                font-size: 20px;
              }

              .icon-rocket::before { content: "🚀"; }
              .icon-business::before { content: "💼"; }
            }

            h3 {
              font-size: 24px;
              font-weight: bold;
              color: #1e3c72;
              margin: 0;
            }
          }

          .section-content {
            p {
              font-size: 16px;
              line-height: 1.8;
              color: #555;
              text-align: justify;
              margin-bottom: 15px;
            }

            .business-categories {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 30px;

              .category-item {
                h4 {
                  font-size: 18px;
                  font-weight: bold;
                  color: #1e3c72;
                  margin-bottom: 15px;
                  padding-bottom: 8px;
                  border-bottom: 2px solid #ff6b35;
                }

                .business-list {
                  list-style: none;
                  padding: 0;
                  margin: 0 0 15px 0;

                  li {
                    padding: 8px 0;
                    font-size: 14px;
                    line-height: 1.6;
                    color: #666;
                    position: relative;
                    padding-left: 20px;

                    &::before {
                      content: "•";
                      color: #ff6b35;
                      font-weight: bold;
                      position: absolute;
                      left: 0;
                    }
                  }
                }

                .note-text {
                  font-size: 12px;
                  color: #999;
                  font-style: italic;
                  line-height: 1.5;
                  background: rgba(255, 107, 53, 0.05);
                  padding: 10px;
                  border-radius: 8px;
                  border-left: 3px solid #ff6b35;
                }
              }
            }
          }
        }
      }

      .core-advantages {
        margin-top: 50px;
        padding: 40px;
        background: linear-gradient(135deg, rgba(30, 60, 114, 0.03), rgba(255, 107, 53, 0.03));
        border-radius: 15px;
        border: 1px solid rgba(30, 60, 114, 0.1);

        .advantages-title {
          font-size: 28px;
          font-weight: bold;
          color: #1e3c72;
          text-align: center;
          margin-bottom: 40px;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 60px;
            height: 3px;
            background: linear-gradient(90deg, #1e3c72, #ff6b35);
            border-radius: 2px;
          }
        }

        .advantages-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;

          .advantage-item {
            text-align: center;
            padding: 30px 20px;
            background: white;
            border-radius: 15px;
            border: 1px solid rgba(255, 107, 53, 0.2);
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;

            &::before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              height: 4px;
              background: linear-gradient(90deg, #1e3c72, #ff6b35);
            }

            &:hover {
              transform: translateY(-10px);
              box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
            }

            .advantage-icon {
              width: 70px;
              height: 70px;
              background: linear-gradient(135deg, #ff6b35, #ff8e35);
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0 auto 20px;
              position: relative;

              i {
                color: white;
                font-size: 28px;
              }

              .icon-tech::before { content: "⚙️"; }
              .icon-creative::before { content: "🎨"; }
              .icon-culture::before { content: "🌍"; }
              .icon-license::before { content: "🛡️"; }
            }

            h4 {
              font-size: 18px;
              font-weight: bold;
              color: #1e3c72;
              margin-bottom: 15px;
            }

            p {
              font-size: 14px;
              line-height: 1.6;
              color: #666;
              margin: 0;
            }
          }
        }
      }
    }
  }
}
</style>